<template>
  <v-container v-if="installer">
    <installer-add-fusion-solar-access-dialog
      v-model="addAccessDialog"
      v-on:add-access="addAccess($event)"
    />
    <v-row>
      <v-col>
        <v-row justify="space-between">
          <v-col lg="4" sm="8">
            <h1 class="display-1 font-weight-light">
              {{ installer.name }}
            </h1>
          </v-col>
          <v-col lg="2" align="right">
            <v-btn
              v-if="editMode"
              outlined
              color="blue"
              v-on:click="saveInstaller"
            >
              <v-icon left>mdi-content-save</v-icon>
              {{ $t("Generic.Save") }}
            </v-btn>
            <v-btn v-else outlined color="blue" v-on:click="switchEditMode">
              <v-icon left>mdi-pencil</v-icon>
              {{ $t("Generic.Edit") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-divider class="pb-5"></v-divider>
        <v-row justify="space-between">
          <v-col cols="12">
            <h1 class="subtitle-1 font-weight-light">
              Sites associés
            </h1>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="headersSites"
              :items="installer.sites"
              :no-data-text="$t('Generic.No_Data')"
              :footer-props="{
                itemsPerPageText: $t('Generic.Rows_per_page')
              }"
            >
            </v-data-table>
          </v-col>
        </v-row>
        <v-row justify="space-between">
          <v-col cols="12">
            <h1 class="subtitle-1 font-weight-light">
              Clés FusionSolar associées
            </h1>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="headersAccesses"
              :items="installer.fusionSolarAccesses"
              :no-data-text="$t('Generic.No_Data')"
              :footer-props="{
                itemsPerPageText: $t('Generic.Rows_per_page')
              }"
            >
              <template v-if="editMode" v-slot:item.Actions="{ item }">
                <v-btn
                  text
                  icon
                  color="red"
                  class="ma-0 pa-0"
                  v-on:click="removeAccess(item)"
                >
                  <v-icon class="ma-0 pa-0">mdi-close</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <v-btn
              v-if="editMode"
              class="mt-2"
              rounded
              depressed
              small
              v-on:click="addAccessDialog = true"
            >
              <v-icon color="primary" class="pr-1">mdi-plus</v-icon>
              {{ $t("Installer_Details.Add_FusionSolar_Access_Binding") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ConstantsValues from "../constants/constants";
import InstallerService from "../services/InstallerService";
import InstallerAddFusionSolarAccessDialog from "@/components/Installers/InstallerAddFusionSolarAccessDialog.vue";

export default {
  components: {
    InstallerAddFusionSolarAccessDialog
  },
  data() {
    return {
      addAccessDialog: false,
      editMode: false,
      installer: undefined,
      rowsPerPage: 10,
      headersSites: [
        {
          text: this.$i18n.t("Generic.Name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$i18n.t("Generic.Actions"),
          value: "Actions",
          align: "right",
          sortable: false
        }
      ],
      headersAccesses: [
        {
          text: this.$i18n.t("Manage_Installers.UserName"),
          align: "left",
          value: "userName"
        },
        {
          text: this.$i18n.t("Generic.Actions"),
          value: "Actions",
          align: "right",
          sortable: false
        }
      ],
      accessesActions: []
    };
  },
  methods: {
    switchEditMode() {
      this.editMode = true;
    },
    saveInstaller() {
      const udpatedInstaller = {
        id: this.installer.id,
        name: this.installer.name,
        fusionSolarAccesses: this.accessesActions
      }

      InstallerService.UpdateInstaller(udpatedInstaller)
        .then(response => {
          console.log(response.data);

          this.editMode = false;
        })
        .catch(e => {
          this.$emit(
            "show-error",
            this.$i18n.t("Error.Installer_Not_Retrieved")
          );
          this.$router.push({
            name: "Installers"
          });
        });
    },
    addAccess(access) {
      access.id = undefined;

      this.accessesActions.push({
        action: ConstantsValues.Actions.Add,
        ...access
      });

      this.installer.fusionSolarAccesses.push(access);
      this.addAccessDialog = false;
    },
    removeAccess(access) {
      if (!access.id) {
        const indexAction = this.accessesActions.findIndex(
          a =>
            a.userName === access.userName &&
            a.password === access.password &&
            a.action === ConstantsValues.Actions.Add
        );

        if (indexAction !== -1) {
          this.accessesActions.splice(indexAction, 1);
        }

        const index = this.installer.fusionSolarAccesses.findIndex(
          a =>
            a.userName === access.userName &&
            a.password === access.password &&
            a.id === undefined
        );

        if (index !== -1) {
          this.installer.fusionSolarAccesses.splice(index, 1);
        }
      } else {
        this.installer.fusionSolarAccesses = this.installer.fusionSolarAccesses.filter(
          a => a.id === access.id
        );

        this.accessesActions.push({
          id: access.id,
          action: ConstantsValues.Actions.Delete
        });
      }

      console.log(this.accessesActions);
    }
  },
  mounted() {
    const id = this.$route.params.id;

    InstallerService.GetInstaller(id)
      .then(response => {
        this.installer = response.data;
      })
      .catch(e => {
        this.$emit("show-error", this.$i18n.t("Error.Installer_Not_Retrieved"));
        this.$router.push({
          name: "Installers"
        });
      });
  }
};
</script>
